module.exports = __webpack_public_path__ + "img/Partner_07.9c7a512b.png";